import React from 'react';

export default function PlatformIntegrityPolicy() {
  return (
    <div className="space-y-8 bg-white min-h-screen p-8">
      <h1 className="text-3xl font-bold text-purple-400 text-center">Platform Integrity & Market Fairness Policy</h1>

      <p className="text-gray-700">
        Million2Trillion (M2T) operates under a strict global integrity protocol to ensure market safety, trust, and verified behavior for all members.
      </p>

      <h2 className="text-2xl font-semibold text-purple-400">Zero Manipulation Standard</h2>
      <ul className="list-disc text-gray-700 space-y-3 pl-6">
        <li>No insider trading, market pumping, or artificial price manipulation allowed inside the M2T ecosystem.</li>
        <li>All market signals, investment advice, and financial discussions must be fully transparent and based on authentic analysis or expertise.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-purple-400">Verified Identity Enforcement</h2>
      <ul className="list-disc text-gray-700 space-y-3 pl-6">
        <li>All financial contributors (educators, advisors, analysts, coders, influencers) must operate under verified legal identity.</li>
        <li>Anonymous accounts are not permitted for professional service offerings inside M2T.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-purple-400">Conflict of Interest Transparency</h2>
      <ul className="list-disc text-gray-700 space-y-3 pl-6">
        <li>Any personal investment holdings, brokerage affiliations, paid promotions, or third-party product relationships must be fully disclosed.</li>
        <li>Hidden sponsorships, hidden affiliate commissions, or non-transparent collaborations will result in disciplinary actions.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-purple-400">Platform Abuse Prevention</h2>
      <ul className="list-disc text-gray-700 space-y-3 pl-6">
        <li>Use of bots, click-farms, automated content spamming, or artificial popularity boosting is prohibited.</li>
        <li>Members must not impersonate other verified users, hack other accounts, or misuse platform data for unfair competitive advantage.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-purple-400">Violation Consequences</h2>
      <ul className="list-disc text-gray-700 space-y-3 pl-6">
        <li>Account suspension, permanent ban, or legal reporting depending on severity of violation.</li>
        <li>Loss of earned badges, credibility scores, and monetization privileges.</li>
        <li>Platform-wide visibility bans if proven to harm market trust or endanger financial users.</li>
      </ul>

      <p className="text-gray-500 italic">
        M2T operates under “verified market integrity first” — we protect all verified users from unethical and unqualified behavior.
      </p>
    </div>
  );
}
